module.exports = __webpack_public_path__ + "static/media/employee-recognition.a7578447.svg";